import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../../services/shared.service';
import { last, Subject, Subscription } from 'rxjs';
import { debounceTime, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-work-calendar',
  standalone: false,
  templateUrl: './work-calendar.component.html',
  styleUrl: './work-calendar.component.css'
})
export class WorkCalendarComponent {
  @ViewChild('employee') employee!: ElementRef;
  searchKeyword$ = new Subject<string>();
  searchSub!: Subscription;
  days: any = [];
  employeeInfo: any = `T3|0941549523 |045200005173 | 946684800000 | 66 Hồ Sĩ Dương|68012491e9cab0670b20274e|3
  T4|0941549524 |045200005174 |  200-100 | 66 Hồ Sĩ Dương|68012491e9cab0670b20274e|4`
  selectedRoles: any;
  shareObject: any = {
    selectedRows: new Set(),
    userSelectedRows: new Set(),
    timeSheetSelectedRows: new Set(),
    // selectedUserOptions: [],
    // selectedTimesheetOptions: [],
    lastSelectedIndex: null,
    lastSelectedUserIndex: null,
    lastSelectedTimesheetIndex: null,
    checkList: [],
  };
  formHandle!: FormGroup;
  filterForm!: FormGroup
  constructor(
    public sharedService: SharedService,
    private translate: TranslateService,
    private router: Router,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
    this.shareObject.options = { filter: {}, filterUser: {}, page: 1, limit: this.sharedService.env.pageSize[0] };
    this.activatedRoute.params.subscribe((params) => {
      if (params['id']) {
        this.shareObject.id = params['id'];
      }
      if (params['timesheet']) {
        this.shareObject.filterTimesheet = params['timesheet'];
        this.shareObject.options.filter.timesheet = { $elemMatch: { $eq: params['timesheet'] } };
      }
    })
  }
  ngOnInit(): void {
    this.shareObject.days = this.sharedService.env.timesheetDays;
    this.shareObject.data = this.activatedRoute.snapshot.data;
    this.formHandle = this.fb.group({
      // workDate: ['', [Validators.required]],
      employee: ['', [Validators.required]],
      timesheet: ['', [Validators.required]],
      status: [1],
    });
    if (this.sharedService.env.production === false && this.shareObject.data.type == 'add') {
      this.formHandle.patchValue({
        // workDate: new Date().toISOString().split('T')[0],
        employee: '',
        status: 1,
        timesheet: '',
      })
    }
    this.filterForm = this.fb.group({
      timesheet: [''],
      'profile.employeeGroup': [''],
      startDate: [''],
      endDate: [''],
      limit: [this.sharedService.env.pageSize[0]],
      keyword: [''],
    })
    if (this.shareObject.data.type == 'edit' || this.shareObject.data.type == 'add') {
      this.shareObject.userName = this.translate.instant('select_user');
    } else {
      // this.getEmployeeGroup();
      this.getItems();
    }
    // this.getUsers();
    // this.getTimesheet();
  }
  getItemsBak() {
    this.shareObject.filterBox = false;
    this.shareObject.isLoading = true;

    this.sharedService.callApi(`/employee_timesheet/list`, { limit: 1000 }).pipe(
      switchMap((res: any) => {
        this.shareObject.timesheets = res.data.data;
        return this.sharedService.callApi('/employee_group/list', { limit: 1000 })
      }),
      switchMap((res: any) => {
        this.shareObject.employeeGroups = res.data.data;
        return this.sharedService.callApi('/users/list', this.shareObject.options)
      }),
      switchMap((res: any) => {
        let userIds = res.data.data.map((e: any) => e.id);
        this.shareObject.users = res.data.data;
        return this.sharedService.callApi(`/work_calendar/list`, { filter: { employee: { $in: userIds } } })
      }),
    ).subscribe((res: any) => {
      this.shareObject.users = this.shareObject.users?.map((e: any) => {
        let calendar = res.data.data.find((item: any) => e.id == item.employee.id);
        e.timesheet = calendar?.timesheet;
        e.calendarId = calendar?.id;
        return e;
      })
      this.shareObject.isLoading = false
      console.log(this.shareObject.users)
    });

    // this.sharedService.callApi(path, this.shareObject.options).subscribe({
    //   next: (res: any) => {
    //     this.shareObject.isLoading = false
    //     this.shareObject.items = res.data.data.map((e: any) => {
    //       e.statusText = e.status == 0 ? this.translate.instant('status_inactive') : this.translate.instant('status_active')
    //       // e.delayMinute = Math.floor(e.delay / 60000);
    //       e.timesheets = e.timesheet.map((item: any) => item.name)
    //       return e;
    //     });

    //     this.shareObject.users = this.shareObject.users?.map((e: any) => {
    //       let calendar = res.data.data.find((item: any) => e.id == item.employee.id);
    //       e.timesheet = calendar?.timesheet;
    //       e.calendarId = calendar?.id;
    //       return e;
    //     })
    //     console.log(this.shareObject.users)
    //     this.shareObject.pagination = res.data.pagination;
    //   },
    //   error: (err: any) => {
    //     this.shareObject.isLoading = false
    //     this.sharedService.toast({
    //       title: this.translate.instant('error'),
    //       message: err.error.message,
    //       type: 'danger',
    //     });
    //   }
    // })
  }
  getItems() {
    this.shareObject.filterBox = false;
    this.shareObject.isLoading = true;
    this.sharedService.callApi(`/work_calendar/get_by_user`, this.shareObject.options).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false;
        this.shareObject.timesheets = res.timesheet;
        this.shareObject.employeeGroups = res.employeeGroups;
        this.shareObject.pagination = res.data.pagination;
        this.shareObject.users = res.data.data;
        // this.shareObject.users = this.shareObject.data.type == 'list' ?
        //   res.data.data.filter((e: any) => (e.workcalendar && e.workcalendar?.deletedAt == null)|| !e.workcalendar) :
        //   res.data.data.filter((e: any) => e.workcalendar && e.workcalendar?.deletedAt != null);
        if (this.shareObject.filterTimesheet) {
          this.shareObject.timesheetName = this.shareObject.timesheets.find((e: any) => e.id == this.shareObject.filterTimesheet)?.name;
        }
        // this.formHandle.patchValue({
        //   timesheet: res.data.data[0].id
        // })
        // if (this.shareObject.data.type == 'edit') {
        //   this.getItem()
        // }
      },
      error: (err: any) => {
        this.shareObject.isLoading = false;
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
    })


  }
  getItem() {
    this.shareObject.isLoading = true
    this.sharedService.callApi(`/work_calendar/get`, { id: this.shareObject.id }).subscribe({
      next: (res: any) => {
        this.formHandle.patchValue({
          employee: res.data.employee.id,
          timesheet: res.data.timesheet,
          status: res.data.status,
        });
        console.log(this.shareObject)
        this.shareObject.userName = res.data?.employee?.profile?.name;
        this.shareObject.email = res.data?.employee?.email;
        this.shareObject.timeSheetSelectedRows = new Set(res.data.timesheet.map((item: any) => this.shareObject.timesheets.findIndex((e: any) => e.id == item.id)));
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
      complete: () => {
        this.shareObject.isLoading = false
      }
    })
  }
  getTimesheetValue(user: any) {
    console.log(user)
    this.shareObject.checkList = this.shareObject.timesheets.filter((item: any) => user.workcalendar?.timesheet?.some((e: any) => e.id == item.id)).map((item: any) => item.id);
    this.shareObject.timesheets = this.shareObject.timesheets.map((e: any) => {
      e.checked = this.shareObject.checkList.includes(e.id);
      return e;
    })
    this.shareObject.userCalendar = user.workcalendar.id;
    this.sharedService.modalControl('#addcalendar');
  }
  addItem(timeSheetSelected: any, userSelected: any) {
    let payload: any = [];
    for (const employee in userSelected) {
      payload.push({
        employee: userSelected[employee],
        timesheet: timeSheetSelected,
      })
    }
    this.shareObject.isLoading = true
    this.sharedService.callApi(`/work_calendar/add_many`, { data: payload }).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.shareObject.isLoading = false;
          this.sharedService.toast({
            title: this.translate.instant('success'),
            message: this.translate.instant('add_success'),
            type: 'success',
          });
          this.sharedService.modalControl('#addcalendar', false);
          this.shareObject.timeSheetSelectedRows.clear();
          this.shareObject.selectedRows.clear();
          // this.shareObject.timeSheets =  
          // this.shareObject.users = this.shareObject.users?.map((e: any) => {
          //   e.timesheet = userSelected.includes(e.id) ? this.shareObject.timesheets.filter((item: any) => timeSheetSelected.includes(item.id)) : e.timesheet;
          //   e.calendarId = this.shareObject.timesheets.find((item: any) => item.employee.id == e.id)?.id;
          //   return e;
          // })
          this.getItems();
        } else {
          this.shareObject.isLoading = false
          this.sharedService.toast({
            title: this.translate.instant('error'),
            message: res.message,
            type: 'danger',
          });
        }
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  updateItem(timeSheetSelected: any, userSelected: any) {
    console.log('updateItem', timeSheetSelected, userSelected, this.shareObject.userCalendar);
    // this.shareObject.isLoading = true;
    this.sharedService.callApi(`/work_calendar/update`, {
      id: this.shareObject.userCalendar,
      employee: userSelected,
      timesheet: timeSheetSelected,
    }).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.shareObject.isLoading = false
          this.sharedService.toast({
            title: this.translate.instant('success'),
            message: this.translate.instant('update_success'),
            type: 'success',
          });
          this.sharedService.modalControl('#addcalendar', false);
          this.shareObject.timeSheetSelectedRows.clear();
          this.shareObject.selectedRows.clear();
          delete this.shareObject.userCalendar;
          //update lại timesheet cho user
          console.log(this.shareObject.users)
          this.shareObject.users = this.shareObject.users?.map((e: any) => {
            if (!e.workcalendar) return e;
            e.workcalendar.timesheet = userSelected.includes(e.id) ? this.shareObject.timesheets.filter((item: any) => timeSheetSelected.includes(item.id)) : e.workcalendar.timesheet;
            return e;
          });
          console.log(this.shareObject.users)
          // this.cdRef.detectChanges();
        } else {
          this.shareObject.isLoading = false
          this.sharedService.toast({
            title: this.translate.instant('error'),
            message: this.translate.instant('update_failed'),
            type: 'danger',
          });
        }
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('update_failed'),
          type: 'danger',
        });
      }
    })
  }
  updateBulk(payload: any) {
    this.shareObject.isLoading = true;
    this.sharedService.callApi(`/work_calendar/update`, payload).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('update_success'),
          type: 'success',
        });
        this.router.navigate(['/user/employee/calendar']);
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('update_failed'),
          type: 'danger',
        });
      }
    })
  }
  onSubmit() {
    console.log(this.shareObject.timesheets)
    // let timeSheetSelected: any = this.shareObject.timeSheetSelectedRows.size > 0 ? Array.from(this.shareObject.timeSheetSelectedRows).map((index: any) => this.shareObject.timesheets[index].id) : null;
    let timeSheetSelected: any = this.shareObject.checkList;
    let userSelected: any = this.shareObject.selectedRows.size > 0 ? Array.from(this.shareObject.selectedRows).map((index: any) => this.shareObject.users[index].id) : null;
    console.log('userSelected', userSelected, timeSheetSelected);
    if (!userSelected || userSelected.length == 0 || !timeSheetSelected || timeSheetSelected.length == 0) {
      this.sharedService.toast({
        title: this.translate.instant('title_form_invalid'),
        message: this.translate.instant('message_form_invalid'),
        type: 'danger',
      });
      return;
    }
    let userHasCalendar = this.shareObject.users.filter((e: any) => e?.workcalendar).map((e: any) => e.id);
    let isUpdate = userSelected.some((e: any) => userHasCalendar.includes(e));
    if (isUpdate) {
      this.updateItem(timeSheetSelected, userSelected);
    }
    else {
      this.addItem(timeSheetSelected, userSelected)
    }
  }
  deleteItem(ids: any) {
    ids = this.handleIndextoId(ids);
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_delete'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`/work_calendar/delete_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('delete_success'),
              type: 'success',
            });
            this.shareObject.users = this.shareObject.users.map((e: any) => {
              if (ids.includes(e.workcalendar.id)) {
                delete e.workcalendar;
              }
              return e;
            })
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  onPageChange(page: any) {
    this.shareObject.options.page = page;
    this.getItems();
  }
  softDeleteItem(ids: any) {
    ids = this.handleIndextoId(ids);
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_delete'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`/work_calendar/delete_soft_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('delete_success'),
              type: 'success',
            });
            this.shareObject.users = this.shareObject.users.filter((item: any) => !ids.includes(item.workcalendar?.id));
            this.shareObject.selectedRows.clear();
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  restoreItem(ids: any) {
    ids = this.handleIndextoId(ids);
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_restore'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`/work_calendar/restore_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('restore_success'),
              type: 'success',
            });
            this.shareObject.users = this.shareObject.users.filter((item: any) => !ids.includes(item.workcalendar.id));
            this.shareObject.selectedRows.clear();
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  clear() {
    this.shareObject.options = { filter: {}, page: 1, limit: this.sharedService.env.pageSize[0] };
    this.filterForm.reset();
    this.filterForm.patchValue({
      limit: this.sharedService.env.pageSize[0],
      startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      endDate: new Date().toISOString().split('T')[0],
      timesheet: '',
      'profile.employeeGroup': '',
    })
    this.getItems();
  }
  filter(key: any, value: any) {
    if (!value) {
      this.filterForm.patchValue({ [key]: null });
      delete this.shareObject.options.filter[key];
      delete this.shareObject.options.filterUser[key];
    } else {
      this.shareObject.options.filter[key] = value;
    }
    this.shareObject.options.page = 1;
    this.onSearch();
  }
  onSearch() {
    const now = new Date();
    const lastMonth = new Date(now.setMonth(now.getMonth() - 1));
    lastMonth.setHours(0, 0, 0, 0);
    this.shareObject.options.filter.createdAt = { $gte: new Date(lastMonth).getTime(), $lte: new Date(new Date().setHours(23, 59, 59, 999)) };
    this.shareObject.options.filter.createdAt.$gte = this.filterForm.value.startDate && new Date(new Date(this.filterForm.value.startDate).setHours(0, 0, 0, 0));
    this.shareObject.options.filter.createdAt.$lte = this.filterForm.value.endDate && new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59, 999));
    this.shareObject.options.keyword = this.filterForm.value['keyword'] ? this.filterForm.value['keyword'].trim() : undefined;
    this.shareObject.options.page = 1;
    this.shareObject.options.limit = this.filterForm.value['limit'] ? this.filterForm.value['limit'] : this.sharedService.env.pageSize[0];
    let timesheet = this.filterForm.value['timesheet'] ?? undefined;
    let group = this.filterForm.value['profile.employeeGroup'] ?? undefined;
    if (group) {
      this.shareObject.options.filterUser['profile.employeeGroup'] = group;
      this.shareObject.groupName = this.shareObject.employeeGroups.find((e: any) => e.id == group)?.name;
    }
    if (timesheet) {
      this.shareObject.options.filter.timesheet = timesheet == 'empty' ? 'empty' : { $elemMatch: { $eq: timesheet } };
      this.shareObject.timesheetName = timesheet == 'empty' ? this.translate.instant('timesheet_empty') : this.shareObject.timesheets.find((e: any) => e.id == timesheet)?.name;
    }
    this.getItems();
  }
  showInfoTimesheet(item: any) {
    this.sharedService.modalControl('#timesheetInfo', true);
    this.shareObject.timesheetInfo = this.shareObject.timesheets.find((e: any) => e.id == item.id);
    this.shareObject.timesheetInfo.workDays = this.shareObject.timesheetInfo.workDays.map((day: any) => {
      day.dayText = this.shareObject.days.find((d: any) => d.day == day.day)?.name;
      return day;
    });
    console.log(this.shareObject.timesheetInfo);
  }
  isAllSelected(data: any[] = [], type: any = 'selectedRows'): boolean {
    return this.shareObject[type].size === data.length;
  }
  toggleSelectAll(event: Event, data: any[], type: any = 'selectedRows') {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      data.forEach((_, index) => this.shareObject[type].add(index));
    } else {
      this.shareObject[type].clear();
    }
  }
  selectRow(event: MouseEvent, index: number, type: any = 'selectedRows') {
    //check nếu index đã có trong selectedRows thì bỏ chọn
    let lastIndex = type == 'selectedRows' ? 'lastSelectedIndex' : type == 'userSelectedRows' ? 'lastSelectedUserIndex' : 'lastSelectedTimesheetIndex';
    if (this.shareObject[type].has(index)) {
      this.toggleRowSelection(index, type);
      return;
    }
    if (event.ctrlKey || event.metaKey) {
      // Ctrl/Cmd click: toggle selection
      this.toggleRowSelection(index, type);
    } else if (event.shiftKey && this.shareObject[lastIndex] !== null) {
      // Shift click: select range
      this.selectRange(this.shareObject[lastIndex], index, type);
    } else {
      // Regular click: single selection
      this.selectSingleRow(index, type);
    }
    this.shareObject[lastIndex] = index;
  }
  toggleRowSelection(index: number, type: any = 'selectedRows') {
    if (this.shareObject[type].has(index)) {
      this.shareObject[type].delete(index);
    } else {
      this.shareObject[type].add(index);
    }
  }
  selectSingleRow(index: number, type: any = 'selectedRows') {
    this.shareObject[type].clear();
    this.shareObject[type].add(index);
  }
  selectRange(start: number, end: number, type: any = 'selectedRows') {
    this.shareObject[type].clear();
    const [from, to] = [Math.min(start, end), Math.max(start, end)];
    for (let i = from; i <= to; i++) {
      this.shareObject[type].add(i);
    }
  }
  handleIndextoId(idexes: any) {
    const selectedIds = Array.from(idexes).map((index: any) => this.shareObject.users[index].workcalendar.id);
    return selectedIds;
  }
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    this.shareObject.filterBox = false;
  }

  //expand method
  getTimesheet_bak() {
    this.shareObject.isLoading = true
    this.sharedService.callApi(`/employee_timesheet/list`, {}).subscribe({
      next: (res: any) => {
        this.shareObject.timesheets = res.data.data;
        this.formHandle.patchValue({
          timesheet: res.data.data[0].id
        })
        if (this.shareObject.data.type == 'edit') {
          this.getItem()
        }
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
      complete: () => {
        this.shareObject.isLoading = false
      }
    })
  }
  getUsers_bak(keyword: any = null) {
    let options: any = {};
    if (keyword) {
      options.keyword = keyword.trim();
    }
    this.sharedService.callApi('/users/list', options).subscribe({
      next: (res: any) => {
        this.shareObject.users = res.data.data;
        this.getItems();
        //duplicate data for testing *100
        // for (let i = 0; i < 100; i++) {
        //   this.shareObject.users = [...this.shareObject.users, ...res.data.data]
        // }

      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
    })
  }
  getEmployeeGroup_bak() {
    this.sharedService.callApi('/employee_group/list', {}).subscribe({
      next: (res: any) => {
        this.shareObject.employeeGroups = res.data.data;
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
    })
  }

  //check timesheet 
  checked(id: any) {
    if (this.shareObject.checkList.includes(id)) {
      this.shareObject.checkList = this.shareObject.checkList.filter((item: any) => item != id);
    } else {
      this.shareObject.checkList.push(id);
    }
    this.shareObject.isCheckAll = this.shareObject.checkList.length == this.shareObject.timesheets.length;
    this.shareObject.timesheets = this.shareObject.timesheets.map((item: any) => {
      item.checked = this.shareObject.checkList.includes(item.id);
      return item;
    });
    this.cdRef.detectChanges();
  }
  checkAll() {
    this.shareObject.isCheckAll = !this.shareObject.isCheckAll;
    this.shareObject.timesheets = this.shareObject.timesheets.map((item: any) => {
      item.checked = this.shareObject.isCheckAll;
      return item;
    });
    if (this.shareObject.isCheckAll) {
      this.shareObject.checkList = this.shareObject.timesheets.map((item: any) => item.id);
    } else {
      this.shareObject.checkList = [];
    }
    this.cdRef.detectChanges();
  }

}

